/* Ledion · pantallas encendidas.
   - Portada (data-ld-screen-hero): una pantalla que va pasando contenidos de ejemplo.
   - Ficha (data-ld-try): «Prueba tu contenido» con la forma real del producto.
   Todo se dibuja en canvas a la resolución de la pantalla del visitante; la lupa enseña
   los píxeles LED (diodos rojo, verde y azul) con el pitch del producto.
   Sin JavaScript se ve el cartel de respaldo de cada sección. */
(() => {
  if (window.LedionScreens) return;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let fam = 'Montserrat, Arial, sans-serif';
  const F = (w, px) => `${w} ${px}px ${fam}`;
  const ease = (t) => 1 - Math.pow(1 - Math.max(0, Math.min(1, t)), 3);

  /* ---------- Texto ---------- */
  const fitBlock = (ctx, text, maxW, maxH, maxPx, weight = 800, lh = 1.02, maxLines = 3) => {
    const src = String(text || '');
    const words = src.split(/\s+/).filter(Boolean);
    let best = { px: 8, lines: [src] };
    for (let n = 1; n <= Math.min(maxLines, words.length || 1); n++) {
      const target = src.length / n;
      const lines = [];
      let line = '';
      words.forEach((w) => {
        const next = line ? line + ' ' + w : w;
        if (line && next.length > target * 1.15 && lines.length < n - 1) {
          lines.push(line);
          line = w;
        } else line = next;
      });
      if (line) lines.push(line);
      let px = Math.floor(maxPx);
      for (; px > 8; px -= 1) {
        ctx.font = F(weight, px);
        const wide = Math.max(...lines.map((l) => ctx.measureText(l).width));
        if (wide <= maxW && lines.length * px * lh <= maxH) break;
      }
      if (px > best.px) best = { px, lines };
    }
    return best;
  };

  const drawLines = (ctx, block, x, y, weight, color, align = 'left', lh = 1.02) => {
    ctx.font = F(weight, block.px);
    ctx.fillStyle = color;
    ctx.textAlign = align;
    ctx.textBaseline = 'alphabetic';
    block.lines.forEach((l, i) => ctx.fillText(l, x, y + block.px * 0.8 + i * block.px * lh));
    return y + block.lines.length * block.px * lh;
  };

  const rrect = (ctx, x, y, w, h, r) => {
    ctx.beginPath();
    if (ctx.roundRect) ctx.roundRect(x, y, w, h, r);
    else ctx.rect(x, y, w, h);
  };

  /* ---------- Contenidos ---------- */
  const palettes = {
    calido: ['#2b140b', '#c86a2c', '#ffd3a1'],
    azul: ['#0b1a4a', '#3157f6', '#a9d4ff'],
    verde: ['#06281f', '#13906a', '#b9ffd9'],
    rojo: ['#141418', '#e8473b', '#ffd0c9'],
  };

  const shape = (W, H) => (W > H * 4.5 ? 'strip' : H > W * 1.4 ? 'tall' : 'wide');

  const drawStrip = (ctx, W, H, t, bg, parts) => {
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, W, H);
    const base = Math.round(H * 0.52);
    const size = (p) => (p.px ? H * p.px : base);
    const widths = parts.map((p) => {
      ctx.font = F(p.w || 800, size(p));
      return ctx.measureText(p.t).width;
    });
    const gap = base * 1.1;
    const total = widths.reduce((a, b) => a + b, 0) + gap * parts.length;
    const fits = total - gap <= W * 0.94;
    let x = fits ? (W - (total - gap)) / 2 : W - ((t * H * 1.8) % (total + W));
    for (let rep = 0; rep < (fits ? 1 : 2); rep++) {
      parts.forEach((p, i) => {
        ctx.font = F(p.w || 800, size(p));
        ctx.fillStyle = p.c;
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'left';
        ctx.fillText(p.t, x, H * 0.54);
        x += widths[i] + gap;
      });
    }
  };

  const drawOferta = (ctx, W, H, t, o) => {
    const [c1, c2, c3] = palettes[o.pal] || palettes.calido;
    const tag = o.tag || 'OFERTA';
    if (shape(W, H) === 'strip') {
      drawStrip(ctx, W, H, t, c1, [{ t: tag, c: c3, w: 700, px: 0.3 }, { t: o.title, c: '#fff' }, { t: o.sub || '', c: c3, w: 600, px: 0.36 }]);
      return;
    }
    const g = ctx.createLinearGradient(0, 0, W, H);
    g.addColorStop(0, c1);
    g.addColorStop(1, c2);
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);
    for (let i = 0; i < 9; i++) {
      const s = ((i * 97) % 100) / 100;
      const r = (0.05 + s * 0.12) * Math.min(W, H) * 1.6;
      const x = W * ((i * 0.37 + 0.1) % 1);
      const y = H * (1.2 - ((t * (0.04 + s * 0.05) + s) % 1.4));
      const rg = ctx.createRadialGradient(x, y, 0, x, y, r);
      rg.addColorStop(0, 'rgba(255,255,255,0.18)');
      rg.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = rg;
      ctx.fillRect(x - r, y - r, r * 2, r * 2);
    }
    const tall = shape(W, H) === 'tall';
    const pad = Math.min(W, H) * (tall ? 0.1 : 0.08);
    const k = still ? 1 : ease((t % 8) / 0.9);
    const tagPx = Math.max(9, Math.min(W, H) * (tall ? 0.07 : 0.055));
    ctx.font = F(700, tagPx);
    const tagW = ctx.measureText(tag).width + tagPx * 1.4;
    const ty = tall ? H * 0.12 : pad;
    ctx.globalAlpha = k;
    ctx.fillStyle = c3;
    rrect(ctx, pad, ty, tagW, tagPx * 1.8, tagPx * 0.9);
    ctx.fill();
    ctx.fillStyle = c1;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'left';
    ctx.fillText(tag, pad + tagPx * 0.7, ty + tagPx * 0.95);
    const maxW = W - pad * 2;
    const title = fitBlock(ctx, o.title, maxW, H * (tall ? 0.42 : 0.5), Math.min(W, H) * (tall ? 0.42 : 0.34), 800, 1.0, tall ? 4 : 2);
    const blockH = title.lines.length * title.px;
    const y0 = tall ? H * 0.28 : H * 0.52 - blockH * 0.55;
    ctx.save();
    ctx.translate(0, (1 - k) * H * 0.06);
    const y = drawLines(ctx, title, pad, y0, 800, '#fff', 'left', 1.0);
    if (o.sub) {
      const sub = fitBlock(ctx, o.sub, maxW, H * 0.2, Math.min(W, H) * (tall ? 0.09 : 0.07), 600, 1.2, tall ? 3 : 1);
      drawLines(ctx, sub, pad, y + title.px * 0.25, 600, c3, 'left', 1.2);
    }
    ctx.restore();
    ctx.globalAlpha = 1;
    if (!still) {
      const sx = ((t % 5) / 5) * (W + H) * 1.6 - H;
      const sg = ctx.createLinearGradient(sx, 0, sx + H * 0.5, H);
      sg.addColorStop(0, 'rgba(255,255,255,0)');
      sg.addColorStop(0.5, 'rgba(255,255,255,0.10)');
      sg.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sg;
      ctx.fillRect(0, 0, W, H);
    }
  };

  const drawMenu = (ctx, W, H, t, o) => {
    const bg = '#16110d';
    const acc = '#f2b45a';
    const given = (o.dishes || []).map((d) => String(d).trim()).filter(Boolean);
    const dishes = (given.length ? given : ['Crema de calabaza', 'Pollo al curry con arroz', 'Tarta de queso']).slice(0, 3);
    const labels = ['PRIMERO', 'SEGUNDO', 'POSTRE'];
    if (shape(W, H) === 'strip') {
      drawStrip(ctx, W, H, t, bg, [{ t: String(o.title || '').toUpperCase(), c: acc }, { t: o.price || '', c: '#fff' }, ...dishes.map((d) => ({ t: d, c: '#e9dccb', w: 600, px: 0.36 }))]);
      return;
    }
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, W, H);
    const rg = ctx.createRadialGradient(W * 0.85, H * 0.1, 0, W * 0.85, H * 0.1, Math.max(W, H) * 0.8);
    rg.addColorStop(0, 'rgba(242,180,90,0.22)');
    rg.addColorStop(1, 'rgba(242,180,90,0)');
    ctx.fillStyle = rg;
    ctx.fillRect(0, 0, W, H);
    const tall = shape(W, H) === 'tall';
    const pad = Math.min(W, H) * (tall ? 0.1 : 0.08);
    const cycle = t % 9;
    const colW = (tall ? W : W * 0.44) - pad * 2;
    const titleB = fitBlock(ctx, o.title, colW, H * 0.3, Math.min(W, H) * (tall ? 0.16 : 0.15), 800, 1.0, tall ? 3 : 2);
    const y = drawLines(ctx, titleB, pad, tall ? H * 0.08 : pad * 1.2, 800, acc, 'left', 1.0);
    const pb = fitBlock(ctx, o.price, colW, H * 0.25, Math.min(W, H) * 0.24, 800, 1, 1);
    drawLines(ctx, pb, pad, y + titleB.px * 0.3, 800, '#fff', 'left', 1);
    const listX = tall ? pad : W * 0.48;
    const listW = tall ? W - pad * 2 : W * 0.52 - pad;
    let ly = tall ? H * 0.5 : pad * 1.4;
    const itemPx = Math.min(listW * 0.075, (tall ? H * 0.42 : H - pad * 2.6) / (dishes.length * 2.6));
    dishes.forEach((d, i) => {
      ctx.globalAlpha = still ? 1 : ease((cycle - 0.4 - i * 0.35) / 0.6);
      ctx.font = F(700, itemPx * 0.55);
      ctx.fillStyle = acc;
      ctx.textAlign = 'left';
      ctx.textBaseline = 'alphabetic';
      ctx.fillText(labels[i], listX, ly + itemPx * 0.6);
      const b = fitBlock(ctx, d, listW, itemPx * 2.4, itemPx, 600, 1.15, 2);
      ly = drawLines(ctx, b, listX, ly + itemPx * 0.8, 600, '#f3ece2', 'left', 1.15) + itemPx * 0.7;
      ctx.globalAlpha = 1;
    });
  };

  const drawHorario = (ctx, W, H, t, o) => {
    const now = new Date();
    const clock = now.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    const open = /^\d{1,2}:\d{2}$/.test(o.open || '') ? o.open : '09:00';
    const close = /^\d{1,2}:\d{2}$/.test(o.close || '') ? o.close : '21:00';
    const [ho, mo] = open.split(':').map(Number);
    const [hc, mc] = close.split(':').map(Number);
    const mins = now.getHours() * 60 + now.getMinutes();
    const isOpen = mins >= ho * 60 + mo && mins < hc * 60 + mc;
    const state = isOpen ? 'Abierto' : 'Cerrado';
    const stateC = isOpen ? '#4cf29a' : '#ff7a6e';
    const range = `Hoy de ${open} a ${close}`;
    if (shape(W, H) === 'strip') {
      drawStrip(ctx, W, H, t, '#061226', [{ t: state.toUpperCase(), c: stateC }, { t: range, c: '#fff', w: 600, px: 0.38 }, { t: clock, c: '#9fc3ff', w: 700, px: 0.38 }]);
      return;
    }
    const g = ctx.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, '#071833');
    g.addColorStop(1, '#0d2f66');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);
    const tall = shape(W, H) === 'tall';
    const pad = Math.min(W, H) * 0.1;
    const r = Math.min(W, H) * 0.045;
    const pulse = still ? 0 : (t % 1.6) / 1.6;
    const cx = pad + r;
    const cy = H * 0.3;
    ctx.fillStyle = stateC;
    ctx.globalAlpha = 1 - pulse;
    ctx.beginPath();
    ctx.arc(cx, cy, r * (1 + pulse * 1.8), 0, Math.PI * 2);
    ctx.fill();
    ctx.globalAlpha = 1;
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.fill();
    const sb = fitBlock(ctx, state, W - pad * 2, H * 0.3, Math.min(W, H) * (tall ? 0.3 : 0.26), 800, 1, 1);
    const y = drawLines(ctx, sb, pad, cy + r * 2, 800, '#fff', 'left', 1);
    const rb = fitBlock(ctx, range, W - pad * 2, H * 0.2, Math.min(W, H) * (tall ? 0.09 : 0.08), 600, 1.2, tall ? 2 : 1);
    drawLines(ctx, rb, pad, y + sb.px * 0.2, 600, '#c9dbff', 'left', 1.2);
    ctx.font = F(700, Math.min(W, H) * (tall ? 0.12 : 0.1));
    ctx.fillStyle = 'rgba(255,255,255,0.55)';
    ctx.textAlign = 'right';
    ctx.textBaseline = 'alphabetic';
    ctx.fillText(clock, W - pad, H - pad * 0.8);
  };

  const drawFlow = (ctx, W, H, t) => {
    ctx.fillStyle = '#05060a';
    ctx.fillRect(0, 0, W, H);
    ctx.globalCompositeOperation = 'lighter';
    [['#3157f6', 0.7, 0.0], ['#ff3d7f', 0.55, 1.7], ['#16c7a8', 0.45, 3.1], ['#ffb547', 0.35, 4.4]].forEach(([c, s, p]) => {
      const x = W * (0.5 + 0.38 * Math.sin(t * 0.35 * (1 + s) + p));
      const y = H * (0.5 + 0.34 * Math.cos(t * 0.29 * (1 + s * 0.6) + p * 1.3));
      const r = Math.max(W, H) * (0.32 + 0.08 * Math.sin(t * 0.5 + p));
      const rg = ctx.createRadialGradient(x, y, 0, x, y, r);
      rg.addColorStop(0, c);
      rg.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = rg;
      ctx.fillRect(0, 0, W, H);
    });
    ctx.globalCompositeOperation = 'source-over';
    ctx.strokeStyle = 'rgba(255,255,255,0.10)';
    ctx.lineWidth = Math.max(1, Math.min(W, H) * 0.004);
    for (let i = 0; i < 14; i++) {
      ctx.beginPath();
      for (let x = 0; x <= W + 1; x += W / 40) {
        const y = H * (0.2 + i * 0.05) + Math.sin((x / W) * 6 + t * 0.8 + i * 0.4) * H * 0.04;
        if (x === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.stroke();
    }
  };

  const mediaReady = (m) => m && ((m.tagName === 'VIDEO' && m.readyState >= 2) || (m.tagName === 'IMG' && m.complete && m.naturalWidth));

  const drawMedia = (ctx, W, H, t, o) => {
    const m = o.media;
    if (!mediaReady(m)) {
      drawFlow(ctx, W, H, t);
      if (o.placeholder) {
        const b = fitBlock(ctx, o.placeholder, W * 0.84, H * 0.4, Math.min(W, H) * 0.12, 700, 1.1, 3);
        drawLines(ctx, b, W / 2, H / 2 - (b.lines.length * b.px * 1.1) / 2, 700, '#fff', 'center', 1.1);
      }
      return;
    }
    const mw = m.videoWidth || m.naturalWidth;
    const mh = m.videoHeight || m.naturalHeight;
    const z = 1 + (m.tagName === 'IMG' && !still ? 0.06 * ((Math.sin(t * 0.15) + 1) / 2) : 0);
    const s = Math.max(W / mw, H / mh) * z;
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, W, H);
    ctx.drawImage(m, (W - mw * s) / 2, (H - mh * s) / 2, mw * s, mh * s);
  };

  const painters = { oferta: drawOferta, menu: drawMenu, horario: drawHorario, media: drawMedia };

  /* ---------- Lupa: diodos rojo, verde y azul alrededor de un punto ----------
     lc: canvas de la lupa (con su dpr); ledCtx: contenido reducido a la resolución LED;
     (fx, fy): punto en píxeles LED; (cx, cy): centro de la lupa en px CSS. */
  const drawLoupe = (lc, dpr, ledCtx, ledW, ledH, fx0, fy0, cx, cy, R, label) => {
    const span = Math.min(11, ledW, ledH);
    const sx = Math.max(0, Math.min(ledW - span, Math.floor(fx0 - span / 2)));
    const sy = Math.max(0, Math.min(ledH - span, Math.floor(fy0 - span / 2)));
    const data = ledCtx.getImageData(sx, sy, span, span).data;
    lc.setTransform(dpr, 0, 0, dpr, 0, 0);
    const cell = (R * 2) / span;
    const ox = cx - R;
    const oy = cy - R;
    lc.save();
    lc.beginPath();
    lc.arc(cx, cy, R, 0, Math.PI * 2);
    lc.clip();
    lc.fillStyle = '#020203';
    lc.fillRect(ox, oy, R * 2, R * 2);
    for (let y = 0; y < span; y++) {
      for (let x = 0; x < span; x++) {
        const i = (y * span + x) * 4;
        const px = ox + x * cell;
        const py = oy + y * cell;
        lc.fillStyle = '#101115';
        rrect(lc, px + cell * 0.1, py + cell * 0.1, cell * 0.8, cell * 0.8, cell * 0.18);
        lc.fill();
        const ch = [data[i], data[i + 1], data[i + 2]];
        ['255,40,40', '40,255,90', '60,110,255'].forEach((rgb, k) => {
          const v = ch[k] / 255;
          if (v < 0.03) return;
          lc.fillStyle = `rgba(${rgb},${Math.min(1, 0.25 + v * 1.3)})`;
          lc.beginPath();
          lc.arc(px + cell * (0.28 + k * 0.22), py + cell * 0.5, cell * 0.11 * (0.75 + v * 0.55), 0, Math.PI * 2);
          lc.fill();
        });
      }
    }
    lc.globalCompositeOperation = 'lighter';
    lc.globalAlpha = 0.4;
    lc.drawImage(ledCtx.canvas, sx, sy, span, span, ox, oy, span * cell, span * cell);
    lc.globalAlpha = 1;
    lc.globalCompositeOperation = 'source-over';
    lc.restore();
    lc.lineWidth = 3;
    lc.strokeStyle = '#fff';
    lc.beginPath();
    lc.arc(cx, cy, R, 0, Math.PI * 2);
    lc.stroke();
    if (label) {
      lc.font = F(600, 11);
      const tw = lc.measureText(label).width + 16;
      lc.fillStyle = 'rgba(255,255,255,0.95)';
      rrect(lc, cx - tw / 2, cy + R - 12, tw, 22, 11);
      lc.fill();
      lc.fillStyle = '#121316';
      lc.textAlign = 'center';
      lc.textBaseline = 'middle';
      lc.fillText(label, cx, cy + R - 1);
    }
  };

  /* ---------- Pantalla con lupa ---------- */
  const screens = [];

  class Screen {
    constructor(el, { ledW, ledH, pitch, label }) {
      this.el = el;
      this.c = el.querySelector('canvas.ld-screen__content');
      this.l = el.querySelector('canvas.ld-screen__loupe');
      this.ctx = this.c.getContext('2d');
      this.lctx = this.l.getContext('2d');
      this.ledW = Math.max(8, Math.round(ledW));
      this.ledH = Math.max(8, Math.round(ledH));
      this.label = label;
      this.led = document.createElement('canvas');
      this.led.width = this.ledW;
      this.led.height = this.ledH;
      this.ledCtx = this.led.getContext('2d', { willReadFrequently: true });
      this.visible = true;
      this.pointer = null;
      this.render = () => {};
      this.resize();
      new ResizeObserver(() => this.resize()).observe(el);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((e) => {
          this.visible = e[0].isIntersecting;
        }).observe(el);
      }
      const move = (e) => {
        const r = this.c.getBoundingClientRect();
        this.pointer = { x: e.clientX - r.left, y: e.clientY - r.top };
      };
      this.c.addEventListener('pointermove', (e) => {
        if (e.pointerType === 'mouse' || e.buttons) move(e);
      });
      this.c.addEventListener('pointerdown', move);
      this.c.addEventListener('pointerleave', () => (this.pointer = null));
      this.c.addEventListener('pointerup', (e) => {
        if (e.pointerType !== 'mouse') this.pointer = null;
      });
      this.c.addEventListener('pointercancel', () => (this.pointer = null));
      el.classList.add('is-live');
      screens.push(this);
    }

    resize() {
      const r = this.c.getBoundingClientRect();
      this.dpr = Math.min(2, window.devicePixelRatio || 1);
      this.W = Math.max(1, r.width);
      this.H = Math.max(1, r.height);
      [this.c, this.l].forEach((cv) => {
        cv.width = Math.max(1, Math.round(this.W * this.dpr));
        cv.height = Math.max(1, Math.round(this.H * this.dpr));
      });
    }

    frame(t) {
      this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
      this.ctx.globalAlpha = 1;
      this.ctx.globalCompositeOperation = 'source-over';
      this.render(this.ctx, this.W, this.H, t);
      this.drawLoupe();
    }

    drawLoupe() {
      const lc = this.lctx;
      lc.setTransform(1, 0, 0, 1, 0, 0);
      lc.clearRect(0, 0, this.l.width, this.l.height);
      if (!this.pointer) return;
      this.ledCtx.drawImage(this.c, 0, 0, this.ledW, this.ledH);
      drawLoupe(
        lc,
        this.dpr,
        this.ledCtx,
        this.ledW,
        this.ledH,
        (this.pointer.x / this.W) * this.ledW,
        (this.pointer.y / this.H) * this.ledH,
        this.pointer.x,
        this.pointer.y,
        Math.min(86, Math.min(this.W, this.H) * 0.45),
        this.label
      );
    }
  }

  const pitchLabel = (pitch, tpl) => (tpl || 'Píxel de [pitch] mm').replace('[pitch]', String(pitch).replace('.', ','));

  /* ---------- Portada ---------- */
  const initHero = (root) => {
    if (root.dataset.ldReady) return;
    root.dataset.ldReady = '1';
    let reel = [];
    try {
      reel = JSON.parse(root.querySelector('[data-ld-reel]').textContent);
    } catch (e) {
      return;
    }
    if (!reel.length) return;
    reel.forEach((r) => {
      if (r.mediaId) {
        r.o = r.o || {};
        const m = document.getElementById(r.mediaId);
        if (m && m.tagName === 'VIDEO') {
          m.muted = true;
          m.play().catch(() => {});
        }
        r.o.media = m;
      }
    });
    const pitch = parseFloat(root.dataset.pitch) || 2.5;
    const screen = new Screen(root.querySelector('.ld-screen'), {
      ledW: (parseFloat(root.dataset.mmW) || 1920) / pitch,
      ledH: (parseFloat(root.dataset.mmH) || 960) / pitch,
      label: pitchLabel(pitch, root.dataset.loupeLabel),
    });
    const cap = root.querySelector('[data-ld-cap]');
    const dots = root.querySelector('[data-ld-dots]');
    const slide = Math.max(3, parseFloat(root.dataset.slide) || 6);
    let idx = 0;
    let start = performance.now() / 1000;
    let prev = null;
    let prevStart = 0;
    const go = (i) => {
      prev = idx;
      prevStart = start;
      idx = i;
      start = performance.now() / 1000;
      if (cap) cap.innerHTML = reel[idx].cap || '';
      if (dots) dots.querySelectorAll('button').forEach((b, k) => b.setAttribute('aria-current', k === idx ? 'true' : 'false'));
    };
    if (dots && reel.length > 1) {
      reel.forEach((r, k) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (dots.dataset.label || 'Contenido') + ' ' + (k + 1));
        b.setAttribute('aria-current', k === 0 ? 'true' : 'false');
        b.addEventListener('click', () => go(k));
        dots.appendChild(b);
      });
    }
    if (cap) cap.innerHTML = reel[0].cap || '';
    const off = document.createElement('canvas');
    screen.render = (ctx, W, H, now) => {
      if (!still && reel.length > 1 && now - start > slide) go((idx + 1) % reel.length);
      const cur = reel[idx];
      (painters[cur.kind] || drawMedia)(ctx, W, H, still ? 1 : now - start, cur.o || {});
      const f = (now - start) / 0.7;
      if (prev !== null && f < 1 && !still) {
        off.width = Math.round(W * screen.dpr);
        off.height = Math.round(H * screen.dpr);
        const octx = off.getContext('2d');
        octx.setTransform(screen.dpr, 0, 0, screen.dpr, 0, 0);
        (painters[reel[prev].kind] || drawMedia)(octx, W, H, now - prevStart, reel[prev].o || {});
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.globalAlpha = 1 - ease(f);
        ctx.drawImage(off, 0, 0);
        ctx.restore();
      }
    };
  };

  /* ---------- Ficha: prueba tu contenido ---------- */
  const initTry = (root) => {
    if (root.dataset.ldReady) return;
    root.dataset.ldReady = '1';
    const pitch = parseFloat(root.dataset.pitch) || 2.5;
    const label = pitchLabel(pitch, root.dataset.loupeLabel);
    const specOut = root.querySelector('[data-ld-spec]');
    const host = root.querySelector('[data-ld-3d]');
    // Respaldo: pantalla plana con lupa si no hay WebGL o no carga el módulo 3D.
    const flat = (content) => {
      if (!host || host.querySelector('.ld-screen')) return;
      const [w, h] = content || [parseFloat(root.dataset.mmW) || 1600, parseFloat(root.dataset.mmH) || 900];
      host.classList.add('is-flat');
      host.innerHTML = '<div class="ld-screen ld-try3d__flat"><canvas class="ld-screen__content"></canvas><canvas class="ld-screen__loupe" aria-hidden="true"></canvas><span class="ld-screen__glare" aria-hidden="true"></span></div>';
      const el = host.querySelector('.ld-screen');
      el.style.aspectRatio = `${w} / ${h}`;
      if (h > w) el.style.height = '100%';
      else el.style.width = '100%';
      const sc = new Screen(el, { ledW: w / pitch, ledH: h / pitch, label });
      sc.render = (ctx, W, H, now) => paint(ctx, W, H, now);
      if (!running) {
        running = true;
        requestAnimationFrame(loop);
      }
    };
    const form = root.querySelector('form');
    const st = { kind: 'oferta', media: null };
    let t0 = performance.now() / 1000;
    const val = (name) => {
      const el = form.querySelector(`[name="${name}"]`);
      return el ? el.value.trim() : '';
    };
    const opts = () => ({
      title: st.kind === 'menu' ? val('menu_title') || 'Menú del día' : val('title') || '—',
      sub: val('sub'),
      pal: (form.querySelector('input[name="pal"]:checked') || {}).value || 'calido',
      price: val('menu_price'),
      open: val('open'),
      close: val('close'),
      media: st.media,
      placeholder: root.dataset.mediaPlaceholder || '',
    });
    const paint = (ctx, W, H, now) => (painters[st.kind] || drawOferta)(ctx, W, H, still ? 1 : now - t0, opts());
    // La escena 3D (three.js) se carga cuando la sección se acerca a la pantalla.
    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      if (!root.dataset.module || !host) return flat();
      import(root.dataset.module)
        .then((mod) => {
          const r = mod.mount(root, { paint, loupe: drawLoupe, label, still });
          if (!r.ok) flat(r.content);
          if (r.ok && specOut && r.spec) specOut.textContent = r.spec;
        })
        .catch(() => flat());
    };
    root.ldStart = start;
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (en) => {
          if (en.some((x) => x.isIntersecting)) {
            io.disconnect();
            start();
          }
        },
        { rootMargin: '900px 0px' }
      );
      io.observe(root);
    } else start();
    form.addEventListener('submit', (e) => e.preventDefault());
    form.querySelectorAll('[data-kind]').forEach((b) => {
      b.addEventListener('click', () => {
        st.kind = b.dataset.kind;
        form.querySelectorAll('[data-kind]').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
        form.querySelectorAll('[data-fields]').forEach((f) => (f.hidden = f.dataset.fields !== st.kind));
        t0 = performance.now() / 1000;
      });
    });
    form.addEventListener('change', (e) => {
      if (e.target.name === 'pal') t0 = performance.now() / 1000 - 1;
    });
    const file = form.querySelector('input[type="file"]');
    const note = form.querySelector('[data-file-note]');
    if (file) {
      file.addEventListener('change', () => {
        const f = file.files && file.files[0];
        if (!f) return;
        const url = URL.createObjectURL(f);
        if (f.type.startsWith('video/')) {
          const v = document.createElement('video');
          v.src = url;
          v.muted = true;
          v.loop = true;
          v.playsInline = true;
          v.play().catch(() => {});
          st.media = v;
        } else if (f.type.startsWith('image/')) {
          const img = new Image();
          img.src = url;
          st.media = img;
        } else {
          if (note) note.textContent = note.dataset.bad || '';
          return;
        }
        if (note) note.textContent = f.name + (note.dataset.ok ? ' · ' + note.dataset.ok : '');
      });
    }
  };

  /* ---------- Bucle común ---------- */
  let running = false;
  const loop = (ms) => {
    const now = ms / 1000;
    screens.forEach((s) => {
      if (s.visible && document.body.contains(s.el)) s.frame(now);
    });
    requestAnimationFrame(loop);
  };

  const init = (scope = document) => {
    const css = getComputedStyle(document.documentElement).getPropertyValue('--font-heading-family').trim();
    if (css) fam = css;
    scope.querySelectorAll('[data-ld-screen-hero]').forEach(initHero);
    scope.querySelectorAll('[data-ld-try]').forEach(initTry);
    if (!running && screens.length) {
      running = true;
      requestAnimationFrame(loop);
    }
  };

  const boot = () => {
    const fonts = document.fonts && document.fonts.load
      ? Promise.race([
          Promise.all([document.fonts.load(F(800, 40)), document.fonts.load(F(600, 20)), document.fonts.load(F(700, 20))]),
          new Promise((r) => setTimeout(r, 1500)),
        ])
      : Promise.resolve();
    fonts.then(() => init(), () => init());
  };

  window.LedionScreens = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
